import { TaskCenterTypes } from '@frontend/api-task-center';
import { i18next } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { StatusSwitcherVariants } from '@frontend/design-system';
import { PriorityTaskOption, StatusTaskOption } from '../types';

export const getSwitcherOptions = (
  type: 'priority' | 'status',
  isEditing?: boolean,
  statusValue?: TaskCenterTypes.TaskStatus
) => {
  switch (type) {
    case 'priority': {
      return [
        {
          Icon: (props) => <Icon name='priority-high' color='default' size={16} {...props} />,
          label: i18next.t('High', { ns: 'task-center' }),
          trackingId: '',
          value: TaskCenterTypes.PriorityType.PRIORITY_HIGH,
          variant: statusValue === TaskCenterTypes.TaskStatus.STATUS_COMPLETED ? 'neutral' : 'critical',
        },
        {
          Icon: (props) => <Icon name='priority-medium' size={16} {...props} />,
          label: i18next.t('Medium', { ns: 'task-center' }),
          trackingId: '',
          value: TaskCenterTypes.PriorityType.PRIORITY_MEDIUM,
        },
        {
          Icon: (props) => <Icon name='priority-low' size={16} {...props} />,
          label: i18next.t('Low', { ns: 'task-center' }),
          trackingId: '',
          value: TaskCenterTypes.PriorityType.PRIORITY_LOW,
        },
      ] as PriorityTaskOption[];
    }
    case 'status': {
      return [
        {
          Icon: (props) => <Icon name='pending-small' {...props} />,
          label: i18next.t('To-Do', { ns: 'task-center' }),
          trackingId: '',
          value: TaskCenterTypes.TaskStatus.STATUS_TODO,
          variant: 'default',
        },
        {
          Icon: (props) => <Icon name='in-progress-small' {...props} />,
          label: i18next.t('In Progress', { ns: 'task-center' }),
          trackingId: '',
          value: TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS,
          variant: 'default',
        },
        {
          Icon: (props) => <Icon name='check-small' {...props} />,
          label: i18next.t('Done', { ns: 'task-center' }),
          trackingId: '',
          value: TaskCenterTypes.TaskStatus.STATUS_COMPLETED,
          variant: 'success' as StatusSwitcherVariants,
          hide: !isEditing,
        },
      ] as StatusTaskOption[];
    }
  }
};

export const getLabelFromMap = <T extends Record<string, string>>(map: T, key?: string): string => {
  return key && key in map ? map[key as keyof T] : '';
};
